<template>
  <button
    :class="['button__round', { '--reset': isMax }]"
    :title="isMax ? $t('reset') : $t('next')"
  >
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="button__round-text">
      <path id="round-button-text" fill="none" stroke="none" :d="circlePath(50, 50, 40, false)" />
      <text>
        <textPath href="#round-button-text">{{ isMax ? $t('reset') : $t('next') }}</textPath>
      </text>
    </svg>
    <Icon id="arrow-long" />
  </button>
</template>

<script>
import { Icon } from '@/components/global/index.js'

export default {
  name: 'RoundTextButton',
  props: {
    isMax: {
      type: Boolean,
      required: true,
    },
  },
  components: { Icon },
  methods: {
    circlePath(cx, cy, r, clockwise = true) {
      return `M ${cx} ${cy} m -${r}, 0 a ${r},${r} 0 1,${clockwise ? 1 : 0} ${r * 2},0 a ${r},${r} 0 1,${clockwise ? 1 : 0} -${r * 2},0`
    },
  },
}
</script>
